<template>
  <div class="tab-container">
    <div class="tab-section">
      <div class="title">Aperçu de la carte</div>
      <p class="muted">
        Ci-dessous, voici l’aperçu que les talents ont de votre campagne. Vous pouvez la modifier à tout moment.
      </p>      
      <Button class="primary" label="Modifier la carte" @click="goEditCampaign()" />
      <CampaignCard
        :data="data"
        @changeImage="(event) => emits('changeImage', event)"
        @changePublicName="(event) => emits('changePublicName', event)"
        @changeJobTitle="(event) => emits('changeJobTitle', event)"
        @changeJobDescription="(event) => emits('changeJobDescription', event)"
        @toggleError="(val) => emits('toggleError', val)"
        mode="preview"
        :text_colour="data.text_colour"
        :elem_colour="data.elem_colour"
      />
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
const router = useRouter();

const emits = defineEmits([
  "changeImage",
  "changePublicName",
  "changeJobTitle",
  "changeJobDescription",
  "toggleError",
]);

defineProps({
  data: {
    type: Object,
  },
});

function goEditCampaign () {
  router.push({ name: "editCampaign" });
}

</script>
